<!-- 学习周报-->
<template>
  <div :class="['learnweekReport', { inApp: $root.$data.isApp || isMiniProgram }]">
    <common-title titleName="学习周报" :bcColor="'#F9F9F9'" :zIndex="1000"> </common-title>
    <CommonLoading v-show="beforeLoading" />
    <div v-show="!beforeLoading">
      <div v-show="exampleImg">
        <div class="zhanwei">
          <div class="weekBg">
            <img
              crossorigin="anonymous"
              src="@/assets/img/weekReport/weekreportbg.png?v=4"
              alt=""
            />
            <p v-if="startTime" class="time">{{ startTime }}-{{ endTime }}</p>
          </div>
        </div>

        <TitleInfo :titleInfo="titleInfo" :isShowFont="this.$route.query.isShowFont"></TitleInfo>
        <div class="moreAnswer" v-show="titleInfo.questionCount > 10">
          <AnswerVolume :answerTitinfo="answerTitinfo" :answerData="answerData"></AnswerVolume>
          <CorrectRate :pingjunTitinfo="pingjunTitinfo" :pingjunData="pingjunData"></CorrectRate>
          <ExamPoints
            :fenximathTitinfo="fenximathTitinfo"
            :fenxienglishTitinfo="fenxienglishTitinfo"
            :fenximathData="fenximathData"
            :fenxienglishData="fenxienglishData"
          />
          <SelectsharePop
            v-if="selectsharePop"
            @selectsharepopClose="selectsharepopClose"
            :startTime="startTime"
            :endTime="endTime"
            :titleInfo="titleInfo"
            :answerTitinfo="answerTitinfo"
            :answerData="answerData"
            :pingjunTitinfo="pingjunTitinfo"
            :pingjunData="pingjunData"
            :fenximathTitinfo="fenximathTitinfo"
            :fenxienglishTitinfo="fenxienglishTitinfo"
            :fenximathData="fenximathData"
            :fenxienglishData="fenxienglishData"
          />

          <div class="share-btn" @click="selectsharepopOpen">
            <van-button round block color="#FF7F41" type="info">分享学习报告</van-button>
          </div>
        </div>
        <div v-show="titleInfo.questionCount <= 10" class="littleAnswer">
          <img src="@/assets/img/weekReport/little.png" alt="" />
          <p>本周总答题量过少，在后续的学习中，建议多做题加强练习，祝你早日上岸！</p>
        </div>
      </div>
      <div class="shilitu" v-show="!exampleImg">
        <img src="@/assets/img/weekReport/shilitu.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TitleInfo from './components/titleInfo.vue';
import AnswerVolume from './components/answerVolume.vue';
import CorrectRate from './components/correctRate.vue';
import ExamPoints from './components/examPoints.vue';
import SelectsharePop from './components/selectsharePop.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import CommonLoading from '@/components/commonComponents/CommonLoading.vue';
import { replaceHyphens, whatEev } from '@/utils/tools';
import { getUserMemberCenter, reqWeekDetail } from '@/api/personal/personalReport';

export default {
  components: {
    TitleInfo,
    AnswerVolume,
    CorrectRate,
    ExamPoints,
    SelectsharePop,

    EmptyData,
    CommonLoading,
  },
  data() {
    return {
      beforeLoading: true,
      isMiniProgram: false,
      exampleImg: false,
      startTime: '',
      endTime: '',
      selectsharePop: false,
      defaultAvatar: require('@/assets/img/personalImg/defaultAvatar.png'),
      //顶部数据
      titleInfo: {
        questionCount: 0,
        correctRatio: 0,
        rank: 0,
        userName: '',
        userImg: '',
      },
      // 答题量
      answerTitinfo: {
        questionCount: 0,
        defeatRate: 0,
        week: '',
        value: 0,
        englishQuestionNum: 0,
        mathQuestionNum: 0,
        lastQuestionNum: 0,
      },
      answerData: [],
      //平均率
      pingjunTitinfo: {
        averageCorrectRatio: 0,
        ultraCorrectRatio: 0,
        type: 0,
        ratioType: 0,
        englishUltraCorrectRatio: 0,
        mathUltraCorrectRatio: 0,
        improveSubjectName: '',
        isEnglishRatio: 0,
        isMathRatio: 0,
      },
      pingjunData: [],
      //考点分析
      fenximathTitinfo: {
        knowledgeNum: 0,
        maxKnowledgeName: '',
        minKnowledgeName: '',
      },
      fenxienglishTitinfo: {
        knowledgeNum: 0,
        maxKnowledgeName: '',
        minKnowledgeName: '',
      },
      fenximathData: [],
      fenxienglishData: [],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},

  created() {
    if (whatEev() === 'miniprogram') {
      this.isMiniProgram = true;
    }
  },
  mounted() {
    this.pageShow();
  },
  methods: {
    dealNull(value) {
      return value ? value : 0;
    },
    baseInfo() {
      if (this.userInfo) {
        this.titleInfo.userName = this.userInfo.nickName;
        this.titleInfo.userImg = this.userInfo.avatar ? this.userInfo.avatar : this.defaultAvatar;
      } else {
        this.titleInfo.userName = '--';
        this.titleInfo.userImg = this.defaultAvatar;
      }
    },
    //来吧 展示
    async pageShow() {
      await this.$root.getUserInfo();
      if (this.userInfo.id) {
        //已登录
        this.isCheckMember();
      } else {
        //未登录
        this.beforeLoading = false;
        this.exampleImg = false;
      }
    },
    //是否是会员
    async isCheckMember() {
      const res = await getUserMemberCenter();
      if (res.code === 0) {
        if (res?.data?.level === 0) {
          //普通用户 展示示例图
          this.beforeLoading = false;
          this.exampleImg = false;
        } else {
          //会员  展示正常数据
          this.exampleImg = true;
          this.baseInfo();
          this.getWeekDetail();
        }
      }
    },

    //详情
    async getWeekDetail() {
      if (this.$route.query?.weekId == '' || !this.$route.query?.weekId){
        this.beforeLoading = false;
        this.titleInfo.questionCount = 0;
        // this.exampleImg = false;
        return false;
      }
      const res = await reqWeekDetail(this.$route.query?.weekId);
      //const res = await reqWeekDetail(12);
      if (res.code === 0 && res.data) {
        let allData = res.data;
        this.startTime = allData.statisticsStartTime?.replace(/-/g, '.');
        this.endTime = allData.statisticsEndTime?.replace(/-/g, '.');
        //titleInfo数据
        this.titleInfo.questionCount = allData.questionCount;
        this.titleInfo.correctRatio = allData.correctRatio ? allData.correctRatio : 0;
        this.titleInfo.rank = allData.rank;
        // 答题量分析
        let currentAnsArr = []; //本周答题量
        let lastAnsArr = []; //上周答题量
        let weeks = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
        let weeKey = [
          'monQuestionCount',
          'tuesQuestionCount',
          'wedQuestionCount',
          'thurQuestionCount',
          'friQuestionCount',
          'satQuestionCount',
          'sunQuestionCount',
        ];
        weeKey.map((key, i) => {
          currentAnsArr.push({
            week: weeks[i],
            value: allData?.week ? this.dealNull(allData?.week[key]) : 0,
            name: '本周',
          });
        });
        weeKey.map((key, i) => {
          lastAnsArr.push({
            week: weeks[i],
            value: allData?.lastWeek ? this.dealNull(allData?.lastWeek[key]) : 0,
            name: '上周',
          });
        });
        let maxValue = Math.max(...currentAnsArr.map((x) => x.value));
        let maxWeek = currentAnsArr.filter((item) => item.value === maxValue);
        this.answerTitinfo.questionCount = allData.questionCount;
        this.answerTitinfo.defeatRate = allData.defeatRate;
        this.answerTitinfo.week = maxWeek.length > 0 ? maxWeek[0].week : '';
        this.answerTitinfo.value = maxWeek.length > 0 ? maxWeek[0].value : 0;
        this.answerTitinfo.englishQuestionNum = allData.englishQuestionNum;
        this.answerTitinfo.mathQuestionNum = allData.mathQuestionNum;
        this.answerTitinfo.lastQuestionNum = allData.lastQuestionNum;
        this.answerData = [...currentAnsArr, ...lastAnsArr];
        // 平均正确率
        let mathCorrArr = []; //数学
        let englishtCorrArr = []; //英语
        let corrctTime = ['上周', '本周', '本周平均值'];
        let correctmathKey = [
          'lastMathCorrectRatio',
          'mathCorrectRatio',
          'mathAverageCorrectRatio',
        ];
        let correctenglishKey = [
          'lastEnglishCorrectRatio',
          'englishCorrectRatio',
          'englishAverageCorrectRatio',
        ];
        correctmathKey.map((key, i) => {
          mathCorrArr.push({
            label: '数学',
            type: corrctTime[i],
            value: allData?.correctness ? this.dealNull(allData?.correctness[key]) : '0%',
          });
        });
        correctenglishKey.map((key, i) => {
          englishtCorrArr.push({
            label: '英语',
            type: corrctTime[i],
            value: allData?.correctness ? this.dealNull(allData?.correctness[key]) : '0%',
          });
        });
        if (allData.correctness) {
          let correctDatalist = allData.correctness;

          this.pingjunTitinfo.averageCorrectRatio = correctDatalist['averageCorrectRatio'];
          this.pingjunTitinfo.ultraCorrectRatio = correctDatalist['ultraCorrectRatio'];
          this.pingjunTitinfo.type = correctDatalist['type'];
          this.pingjunTitinfo.ratioType = correctDatalist['ratioType'];
          this.pingjunTitinfo.isEnglishRatio = correctDatalist['isEnglishRatio'];
          this.pingjunTitinfo.isMathRatio = correctDatalist['isMathRatio'];
          this.pingjunTitinfo.englishUltraCorrectRatio =
            correctDatalist['englishUltraCorrectRatio'];
          this.pingjunTitinfo.mathUltraCorrectRatio = correctDatalist['mathUltraCorrectRatio'];
          this.pingjunTitinfo.improveSubjectName = correctDatalist['improveSubjectName'];
          this.pingjunData = [...mathCorrArr, ...englishtCorrArr];
        }

        // 考点分析
        let kdmathArr = [];
        let kdenglishArr = [];
        if (allData.mathTestCenters) {
          let mathDatalist = allData.mathTestCenters;
          this.fenximathTitinfo.knowledgeNum = mathDatalist['knowledgeNum'];
          this.fenximathTitinfo.maxKnowledgeName = mathDatalist['maxKnowledgeName'];
          this.fenximathTitinfo.minKnowledgeName = mathDatalist['minKnowledgeName'];
          mathDatalist.knowledgeVOS?.map((item) => {
            kdmathArr.push({
              year: item.knowledgeName,
              value: item.correctRatio,
            });
          });
        }

        if (allData.englishTestCenters) {
          let englistDatalist = allData.englishTestCenters;

          this.fenxienglishTitinfo.knowledgeNum = englistDatalist['knowledgeNum'];
          this.fenxienglishTitinfo.maxKnowledgeName = englistDatalist['maxKnowledgeName'];
          this.fenxienglishTitinfo.minKnowledgeName = englistDatalist['minKnowledgeName'];

          englistDatalist.knowledgeVOS?.map((item) => {
            kdenglishArr.push({
              year: item.knowledgeName,
              value: item.correctRatio,
            });
          });
        }
        this.fenximathData = kdmathArr;
        this.fenxienglishData = kdenglishArr;
        this.beforeLoading = false;
      }
    },
    //选择分享内容
    selectsharepopOpen() {
      this.selectsharePop = true;
    },
    selectsharepopClose() {
      this.selectsharePop = false;
    },
    //判断是否登录
    // checkLogin() {
    //   if (!this.userInfo.id) {
    //     if (this.$root.$data.isApp) {
    //       this.$sendToApp('login');
    //     } else if (this.$root.miniprogram) {
    //       const url = window.location.href;
    //       const redirctUrl = encodeURIComponent(
    //         `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
    //       );
    //       const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
    //       wx.miniProgram.redirectTo({
    //         url: path,
    //       });
    //     } else {
    //       const { path, query } = this.$route;
    //       this.$router.push({ path: '/registrationLogin', query: { redirect: path, ...query } });
    //     }
    //   } else {
    //     this.isCheckMember();
    //   }
    // },
  },
};
</script>
<style lang="scss" scoped>
.learnweekReport {
  position: relative;
  padding-top: 100px;
  .zhanwei {
    position: relative;
    width: 100%;
    height: 260px;
    // background-color: #33333354;
  }
  .weekBg {
    position: absolute;
    top: 0;
    width: 100%;
    height: 676px;
    margin: 0 auto;
    // background-image: url('../../../assets/img/weekReport/weekreportbg.png');
    // background-repeat: no-repeat;
    // background-size: 100%;
    z-index: 0;
    img {
      position: absolute;
      display: block;
      width: 100%;
    }
    .time {
      position: relative;
      font-size: 25px;
      font-weight: 400;
      color: #ffffff;
      padding-top: 160px;
      padding-bottom: 70px;
      padding-left: 56px;
    }
  }
  .share-btn {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 30px;
    background-color: #fff;
    border-radius: 30px 30px 0 0;
    margin: 0 auto;
  }
}
.moreAnswer {
  padding-bottom: 200px;
}

.littleAnswer {
  position: relative;
  width: 678px;
  height: 832px;
  background: #ffffff;
  box-shadow: 0px 4 11px 0px rgba(0, 0, 0, 0.02);
  border-radius: 14px;
  margin: 0px auto;
  padding-top: 145px;
  img {
    display: block;
    width: 314px;
    height: 226px;
    margin: 0 auto;
  }
  p {
    width: 464px;
    margin: 40px auto 0;
    font-size: 25px;
    text-align: center;
    font-weight: 400;
    color: #333333;
    line-height: 36px;
  }
}
.shilitu {
  img {
    display: block;
    width: 100%;
    margin: 0 auto;
  }
}
.inApp {
  padding-top: 0px;
}
</style>
